import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ClientUpdateRequiredPayload } from '../../types/clientUpdate';

interface ClientUpdateState {
  requirement: ClientUpdateRequiredPayload | null;
}

const initialState: ClientUpdateState = {
  requirement: null,
};

const clientUpdateSlice = createSlice({
  name: 'clientUpdate',
  initialState,
  reducers: {
    clientUpdateRequiredReceived: (
      state,
      action: PayloadAction<ClientUpdateRequiredPayload>
    ) => {
      state.requirement = action.payload;
    },
    clearClientUpdateRequirement: (state) => {
      state.requirement = null;
    },
  },
});

export const { clientUpdateRequiredReceived, clearClientUpdateRequirement } =
  clientUpdateSlice.actions;

export default clientUpdateSlice.reducer;
